import { makeStateStore } from '@playcastdotio/StateStore';

export type UserProfileAccountState = {
  authId: string | null;
  pointsBalance: number;
  totalPointsEarned: number;
  rank: string;
  legacyDays: number;
  timezoneOffsetMinutes: number | null;
  firstSeenAt: string | number | null;
  lastSeenAt: string | number | null;
  frozenAt: string | number | null;
  frozenReason: string | null;
  createdAt: string | number | null;
  updatedAt: string | number | null;
};

const initialState: UserProfileAccountState = {
  authId: null,
  pointsBalance: 0,
  totalPointsEarned: 0,
  rank: 'none',
  legacyDays: 0,
  timezoneOffsetMinutes: null,
  firstSeenAt: null,
  lastSeenAt: null,
  frozenAt: null,
  frozenReason: null,
  createdAt: null,
  updatedAt: null,
};

export const userProfileState = makeStateStore<UserProfileAccountState>(initialState);
